import { render, staticRenderFns } from "./housing.vue?vue&type=template&id=3008f161&scoped=true"
import script from "./housing.vue?vue&type=script&lang=js"
export * from "./housing.vue?vue&type=script&lang=js"
import style0 from "./housing.vue?vue&type=style&index=0&id=3008f161&prod&scoped=true&lang=css"
import style1 from "./housing.vue?vue&type=style&index=1&id=3008f161&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008f161",
  null
  
)

export default component.exports